import Login from './auth/login.component';
import Dashboard from '../pages/dashboard/dashboard.component';
import VerifyUserCompleteRegistration from './auth/verifyandcompletereg.component';
import CreatePassword from './auth/createpassword.component';
import ForgotPassword from './forgotPassword/forgotpassword.component';
import ResetPassword from './forgotPassword/resetpassword.component';
import ChangePassword from '../pages/Initiator/war/changePassword.component';

//Common
import PageNotFound from '../pages/404Page';
import { Routes, Route } from "react-router-dom";

//Initiator
import Initiator from '../pages/Initiator';
import InitiateReport from '../pages/Initiator/war/reports/initiatereport';
import InitiatorProfile from '../pages/Initiator/war/initiatorprofile/initiator.profile';

// profile
import PayrollProfile from '../pages/payroll/WAR/payrollprofile/payroll.profile';

// Approver
import Approver from '../pages/approver/index';
import ApproverProfile from '../pages/approver/war/approverprofile/approver.profile';

// Admin
import AdminProfile from '../pages/admin/adminprofile/admin.profile';

// Masters
import School from '../pages/admin/setting/masters/school/School.component';
import CreateSchool from '../pages/admin/setting/masters/school/createSchool.component';
import Users from '../pages/admin/setting/masters/users/users.component';
import CreateUser from '../pages/admin/setting/masters/users/createUser.component';
import Role from '../pages/admin/role/roll.component';
import Masters from '../pages/admin/setting/masters/masters.component';
import CreateEmployee from '../pages/admin/setting/masters/employee/createEmployee.component';
import EmployeeList from '../pages/admin/setting/masters/employee/employees.component';
import ReportList from '../pages/admin/setting/masters/formreport/formreports.component';
import TimeReportMasterList from '../pages/admin/setting/masters/timereport/timereports.component';
import InitiatePayrollReport from '../pages/payroll/WAR/initiatepayrollreport';
import InitiateApproverReport from '../pages/approver/war/initiateapproverreport';
import WARInitiator from '../pages/Initiator/war/reports/Initiator';
import Payroll from '../pages/payroll';
import WARPayroll from '../pages/payroll/WAR/payroll.component';
import WARApprover from '../pages/approver/war/approver.component';
import PersonalActionFormInitiator from '../pages/Initiator/personal_action_form';
import PersonalActionInitiatorReportlist from '../pages/Initiator/personal_action_form_reportlist';
import PersonalActionArchieveReports from '../pages/Initiator/personal_action_form_reportlist/PersonalActionArchieveReports';
import SuperAdminDashboardPA from '../pages/Initiator/personal_action_form_reportlist/SuperAdminDashboard';
import StipendFormInitiator from '../pages/Initiator/stipend_form';
import ArchiveReportStipendForms from '../pages/stipend_forms/ReportTemplate/ArchiveReport'
import ServiceAgreementInitiatorReportList from '../pages/Initiator/serviceagreement';
import SixPeriodReportList from '../pages/sixperiod';
import ArchivReporte from '../pages/sixperiod/ArchivReporte';
import ServiceAgreementPayrollReportList from '../pages/payroll/serviceagreement';
import TimeReportList from '../pages/time_report';
import TimeReportListSuperAdmin from '../pages/time_report/timeReportSuperAdmin';
import InitiateNewTimeReport from '../pages/time_report/initiateNewReport';
import AllApplicationDashboard from '../pages/dashboard-all-apps';
import WAR_Certificated_Admin_Initiator from '../pages/Initiator/war_certificated_admin/reports/Initiator';
import WAR_Certificated_Admin_Initiate_Request from '../pages/Initiator/war_certificated_admin/reports/initiatereport';
import WAR_Certificated_Admin_Approver from '../pages/approver/war_certificated_admin/approver.component';
import WAR_Certificated_Admin_Initiate_Request_Approver from '../pages/approver/war_certificated_admin/initiateapproverreport';
import WAR_Certificated_Admin_Payroll from '../pages/payroll/war_certificated_admin/payroll.component';
import WAR_Certificated_Admin_Payroll_Initiate_report from '../pages/payroll/war_certificated_admin/initiatepayrollreport';
import HtmlToPdfTimeReport from '../components/time_report/htmlToPdf';
import ClassifiedSubstituteRequestReportList from '../pages/classified_substitute_request';
import HtmlToPdf from '../components/classified_substitute_request/htmlToPdf';
import SubstituteRequestClassifiedReportList from '../pages/Initiator/substituteRequestClassified';

import SubstituteRequestCertificated from '../pages/substitute_request_certificated';
import InitiateNewSubstituteRequestCertificated from '../pages/substitute_request_certificated/initiateNewReport';

import EmployeeHandBook from '../pages/employeehandbook';
import NewHandBook from '../pages/employeehandbook/NewHandBook';
import AssignHandbook from '../pages/employeehandbook/AssignHandbook';
import HandBookEmployeeList from '../pages/employeehandbook/HandBookEmployeeList';
import EmployeeAgreementHandbook from '../pages/employeehandbook/EmployeeAgreementHandbook';
import SixPeriodEmployee from '../pages/sixperiod/sixperiodemployee';
import ReportTemplate from '../pages/stipend_forms/ReportTemplate';
import StipendReportTemplate from '../pages/stipend_forms/ReportTemplate';
import PSAConsultant from '../pages/psaconsultant';
import TermsConditions from '../pages/psaconsultant/terms_conditions';
import PreviewAgreement from '../pages/psaconsultant/preview_agreement';
import StipendEmployee from '../pages/employee/stipend_form/index';
import StipendApprover from '../pages/approver/stipend/index';
import StipendPayroll from '../pages/payroll/stipend_form/index';
import PersonalAgreemenConsultant from '../pages/personalserviceagreement';
import ArchiveReportPSA from '../pages/personalserviceagreement/ArchiveReport';
import PersonalAgreemenConsultantApprover from '../pages/approver/personalserviceagreement';
import PersonalAggrementConsultantPayroll from '../pages/payroll/personalserviceagreement';
import PersonnelActionsReports from '../pages/personnelactionsreports';
import PersonnelActionsInitiatorReports from '../pages/personnelactionsreports/Initiatenewform';
import PersonnelActionsApproverReports from '../pages/personnelactionsreports/approver';
import PersonnelActionsInitiatorList from '../pages/personnelactionsreports/Initiatelist';
import PdfForm from '../components/reportpdftemplate/PdfForm';
import SuperAdminDashboard from '../pages/Initiator/substituteRequestClassified/SuperAdminDashboard';
import SuperAdminDashboardSubReqCert from '../pages/substitute_request_certificated/SuperAdminDashboardSubReqCert';
import SuperAdminDashboardWarCert from '../pages/Initiator/war_certificated_admin/reports/SuperAdminDashboardWarCert';

import SuperAdminWARDashboard from '../pages/Initiator/war/reports/SuperAdminWARDashboard';
import StipendSuperAdminReportList from '../components/stipendSuperAdmin';
import SixPeriodSuperAdminList from '../components/sixthPeriodSuperadmin';
import ArchiveReportWAR from '../pages/Initiator/war/reports/ArchiveReport';
import ArchiveReportWARApprover from '../pages/approver/war/ArchiveReport';
import ArchiveReportWARPayroll from '../pages/payroll/WAR/ArchiveReport';


import ArchiveReportWarCertApprover from '../pages/approver/war_certificated_admin/ArchiveReport';
import ArchiveReportWarCertPayroll from '../pages/payroll/war_certificated_admin/ArchiveReport';

import ServiceAgreementSuperAdminReportList from '../components/psaSuperAdmin';
import WARCertificatedArchiveReport from '../pages/Initiator/war_certificated_admin/reports/ArchiveReport';
import TimeReportArchiveReport from '../pages/time_report/ArchiveReport';
import SubClassifiedArchiveReports from '../pages/Initiator/substituteRequestClassified/ArchiveReport';
import SubstituteArchiveCertificated from '../components/certificatedArchiveTable';


import SubCertificatedArchiveReports from '../pages/substitute_request_certificated/ArchiveReport';
import PSAArchiveReport from '../pages/personalserviceagreement/ArchiveReport copy';

export default function RouteComponent() {
  return (
    <Routes >
      {/* Login */}
      <Route exact path="/" element={<Login />} />
      <Route exact path="/confirmregistration" element={<VerifyUserCompleteRegistration />} />
      <Route exact path="/createpassword" element={<CreatePassword />} />
      <Route exact path="/forgotpassword" element={<ForgotPassword />} />
      <Route exact path="/resetpassword" element={<ResetPassword />} />
      <Route exact path="/changepassword" element={<ChangePassword />} />

      {/* Dashboard */}
      <Route exact path="/dashboard" element={<Dashboard />} />
      <Route exact path="/all-app-dashboard" element={<AllApplicationDashboard />} />

      {/* admin  */}
      <Route exact path="/adminprofile" element={<AdminProfile />} />
      <Route exact path="/managemasters/role" element={<Role />} />
      {/*PSAConsultant*/}
      {/*<Route path="/psaconsultant/:reportId" element={<PSAConsultant />} /> */}
      <Route path="/psaconsultant/:id" element={<PSAConsultant />} />
      <Route path="/psaconsultant/terms_conditions" element={<TermsConditions />} />
      <Route path="/psaconsultant/preview_agreement" element={<PreviewAgreement />} />
      <Route path="/psaconsultant/SuperAdminreports" element={<ServiceAgreementSuperAdminReportList />} />
      <Route path="/personalserviceagreement" element={<PersonalAgreemenConsultant />} />
      <Route path="/personalserviceagreement/:srcReportIdPsa/:type" element={<PersonalAgreemenConsultant />} />

      {/* <Route path="/personalserviceagreement/ArchiveReport" element={<ArchiveReportPSA />} /> */}
      <Route path="/personalserviceagreement/ArchiveReport" element={<PSAArchiveReport />} />

      <Route path="/approver/personalserviceagreement" element={<PersonalAgreemenConsultantApprover />} />
      <Route path="/personnelactionsreports" element={<PersonnelActionsReports />} />
      <Route path="/personnelactionsreports/Initiatenewform" element={<PersonnelActionsInitiatorReports />} />
      <Route path="/personnelactionsreports/approver" element={<PersonnelActionsApproverReports />} />
      <Route path="/personnelactionsreports/Initiatelist" element={<PersonnelActionsInitiatorList />} />


      {/* Initiator */}
      <Route path="/initiator" element={<Initiator />} />
      <Route path="/initiator/weekly_absence_report" element={<WARInitiator />} />
      <Route path="/initiator/weekly_absence_report/:approvedReportId" element={<WARInitiator />} />
      <Route path="/weekly_absent_report_certificated_admin/SuperAdminDashboard" element={<SuperAdminDashboardWarCert />} />
      <Route path="/initiator/weekly_absent_report_certificated_admin" element={<WAR_Certificated_Admin_Initiator />} />
      <Route path="/initiator/weekly_absent_report_certificated_admin/:cerApprovedReportId" element={<WAR_Certificated_Admin_Initiator />} />
      <Route path="/initiator/weekly_absent_report_certificated_admin_initiatereport" element={<WAR_Certificated_Admin_Initiate_Request />} />
      <Route path="/initiator/weekly_absent_report_certificated_admin_initiatereport/:reportId" element={<WAR_Certificated_Admin_Initiate_Request />} />
      <Route path="/initiator/weekly_absent_report_certificated_admin_initiatereport/:reportId/:type" element={<WAR_Certificated_Admin_Initiate_Request />} />
      <Route path="/initiator/reports/initiatereport" element={<InitiateReport />} />
      <Route path="/initiator/reports/initiatereport/:reportId" element={<InitiateReport />} />
      <Route path="/initiator/reports/initiatereport/:reportId/:intStatus" element={<InitiateReport />} />
      <Route path="/initiator/reports/initiatereport/:reportId/:intStatus/:isSuperAdmin" element={<InitiateReport />} />
  
      <Route exact path="/initiatorprofile" element={<InitiatorProfile />} />
      <Route exact path="/initiator/serviceagreement" element={<ServiceAgreementInitiatorReportList />} />
      <Route exact path="/initiator/weekly_absence_report/SuperAdminWARDashboard" element={<SuperAdminWARDashboard />} />

      <Route exact path="/initiator/weekly_absence_report/ArchiveReport" element={<ArchiveReportWAR />} />
      <Route exact path="/initiator/weekly_absent_report_certificated_admin/ArchiveReport" element={<WARCertificatedArchiveReport />} />
      

      
      <Route exact path="/approver/weekly_absent_report_certificated_admin/ArchiveReport" element={<ArchiveReportWarCertApprover />} />
      <Route exact path="/payroll/weekly_absent_report_certificated_admin/ArchiveReport" element={<ArchiveReportWarCertPayroll />} />


      {/* Appover */}
      <Route exact path="/approver" element={<Approver />} />
      <Route exact path="/approver/weekly_absence_report" element={<WARApprover />} />
      <Route exact path="/approver/weekly_absence_report/:editReportId" element={<WARApprover />} />
      <Route exact path="/approver/weekly_absent_report_certificated_admin" element={<WAR_Certificated_Admin_Approver />} />
      <Route exact path="/approver/weekly_absent_report_certificated_admin/:cerEditReportId" element={<WAR_Certificated_Admin_Approver />} />
      <Route exact path="/approver/weekly_absent_report_certificated_admin_initiatereport" element={<WAR_Certificated_Admin_Initiate_Request_Approver />} />

      <Route exact path="/approver/weekly_absence_report/ArchiveReport" element={<ArchiveReportWARApprover />} />
      <Route exact path="/payroll/weekly_absence_report/ArchiveReport" element={<ArchiveReportWARPayroll />} />

      <Route exact path="/approver/initiateapproverrequest" element={<InitiateApproverReport />} />
      <Route exact path="/approverprofile" element={<ApproverProfile />} />

      {/* payroll  */}
      <Route exact path="/payroll" element={<Payroll />} />
      <Route exact path="/payroll/weekly_absence_report" element={<WARPayroll />} />
      <Route exact path="/payroll/weekly_absence_report/:newReportId" element={<WARPayroll />} />
      <Route exact path="/payroll/weekly_absent_report_certificated_admin" element={<WAR_Certificated_Admin_Payroll />} />
      <Route exact path="/payroll/weekly_absent_report_certificated_admin/:cerNewReportId" element={<WAR_Certificated_Admin_Payroll />} />
      <Route exact path="/payroll/weekly_absent_report_certificated_admin_initiatereport" element={<WAR_Certificated_Admin_Payroll_Initiate_report />} />
      <Route exact path="/payroll/initiatepayrollreport" element={<InitiatePayrollReport />} />
      <Route exact path="/payroll/serviceagreement" element={<ServiceAgreementPayrollReportList />} />
      <Route exact path="/payrollprofile" element={<PayrollProfile />} />
      <Route exact path='/payroll/personalserviceagreement' element={<PersonalAggrementConsultantPayroll />}></Route>

      {/* Masters */}
      <Route path="/masters" element={<Masters />} />

      {/* Schools */}
      <Route path="/admin/setting/masters/school" element={<School />} />
      <Route path="/admin/setting/masters/createschool" element={<CreateSchool />} />
      <Route path="/admin/setting/masters/createschool/:editSchoolId" element={<CreateSchool />} />

      {/* Users */}
      <Route path="/admin/setting/masters/users" element={<Users />} />
      <Route path="/admin/setting/masters/createusers/" element={<CreateUser />} />
      <Route path="/admin/setting/masters/createusers/:userId" element={<CreateUser />} />

      {/* Employee */}
      <Route path="/admin/setting/masters/employee" element={<EmployeeList />} />
      <Route path="/admin/setting/masters/createemployee" element={<CreateEmployee />} />
      <Route path="/admin/setting/masters/createemployee/:editEmployeeId" element={<CreateEmployee />} />

      {/* Form Report */}
      <Route path="/admin/setting/masters/formreport" element={<ReportList />} />

      {/* Form Report */}
      <Route path="/admin/setting/masters/timereport" element={<TimeReportMasterList />} />
      
      {/* Common */}
      <Route path="*" element={<PageNotFound />} />
      <Route path='/sixth_period_report_list' element={<SixPeriodReportList />} />
      <Route path='/sixth_period_report_list/ArchiveReport' element={<ArchivReporte />} />
      <Route path='/sixth_period_report_list/:sixPReportId/:type' element={<SixPeriodReportList />} />
      <Route path='/SixthPeriodSuperAdmin' element={<SixPeriodSuperAdminList />} />
      <Route path="/time_report" element={<TimeReportList />} />
      <Route path="/time_report/SuperAdminDashboard" element={<TimeReportListSuperAdmin />} />
      <Route path="/time_report/ArchiveReport" element={<TimeReportArchiveReport />} />
      <Route path="/time_report/:tr_ReportId/:type" element={<TimeReportList />} />
      {/* <Route path="/time_report/:tr_ApproverReportId" element={<TimeReportList />} /> */}
      <Route path="/time_report/:reportIdFromAP" element={<TimeReportList />} />
      <Route path="/timereport/initiatenewreport" element={<InitiateNewTimeReport />} />
      <Route path="/timereport/initiatenewreport/:reportId" element={<InitiateNewTimeReport />} />
      <Route path="/timereport/initiatenewreport/:reportId/:EditByAP" element={<InitiateNewTimeReport />} />
      <Route path="/timereport/initiatenewreport/:reportId/:EditBySA" element={<InitiateNewTimeReport />} />
      <Route path="/timeReport/temp" element={<HtmlToPdfTimeReport />} />

      {/* Personal Action Form */}
      <Route exact path="/initiator/personal_action_form" element={<PersonalActionFormInitiator />} />
      <Route exact path="/initiator/initiatereportlist" element={<PersonalActionInitiatorReportlist />} />
      <Route exact path="/personal_action_form_reportlist/:pa_ReportId/:type" element={<PersonalActionInitiatorReportlist />} />
      <Route exact path="/personal_action_form_reportlist/:pa_ReportId/reject/:type" element={<PersonalActionInitiatorReportlist />} />
      <Route exact path="/personal_action_form_reportliste/ArchiveReport" element={<PersonalActionArchieveReports />} />
      <Route exact path="/Initiator/personal_action_form_reportlist/SuperAdminDashboard" element={<SuperAdminDashboardPA />} />

      {/* Stipend Form */}
      <Route exact path="/initiator/stipend_form" element={<StipendFormInitiator />} />
      <Route path="/stipend_forms/ReportTemplate/ArchiveReport" element={<ArchiveReportStipendForms />} />
      <Route exact path="/stipendSuperAdminform" element={<StipendSuperAdminReportList />} />
      <Route path="/approver/stipend" element={<StipendApprover />} />
      <Route path="/payroll/stipend_list" element={<StipendPayroll />} />

      {/* <Route exact path="/initiator/" element={< />} /> */}

      {/* Stipend Form */}
      <Route exact path="/initiator/substituteRequestClassified" element={<SubstituteRequestClassifiedReportList />} />
     
      {/* <Route exact path="/initiator/" element={< />} /> */}

      {/* classified substitute request */}
      <Route path="/classified_substitute_request" element={<ClassifiedSubstituteRequestReportList />} />
      <Route path="/classified_substitute_request/:pa_ReportId/:type" element={<SubstituteRequestClassifiedReportList />} />
      {/* super admin dashboard */}
      <Route path="/classified_substitute_request/SuperAdminDashboard" element={<SuperAdminDashboard />} />
      <Route path="/classified_substitute_request/ArchiveReport" element={<SubClassifiedArchiveReports />} />

      <Route path="/substitute_request_certificated/ArchiveReport" element={<SubCertificatedArchiveReports />} />

      

      <Route path="/classified_substitute_request/temp" element={<HtmlToPdf />} />
      <Route path="/sixperiodemployee" element={<SixPeriodEmployee />} />

      {/* substitute request Certificated */}
      <Route path="/substitute_request_certificated" element={<SubstituteRequestCertificated />} />
      <Route path="/substitute_request_certificated/ArchiveReport" element={<SubstituteArchiveCertificated />} />
      <Route exact path="/substitute_request_certificated/SuperAdminDashboard" element={<SuperAdminDashboardSubReqCert />} />
      <Route path="/substitute_request_certificated/:reportIdFromAP" element={<SubstituteRequestCertificated />} />

      <Route path="/substitute_request_certificated/:subCer_reportId/:type" element={<SubstituteRequestCertificated />} />
      {/* <Route path="/substitute_request_certificated/:subCer_reportId" element={<SubstituteRequestCertificated />} /> */}
      <Route path="/substitute_request_certificated/initiate_new_report" element={<InitiateNewSubstituteRequestCertificated />} />
      <Route path="/substitute_request_certificated/initiate_new_report/:reportId/:reportStatus" element={<InitiateNewSubstituteRequestCertificated />} />
      {/* <Route path = '/substitute_request_certificated/initiate_new_report/:reportId/:status' exact component = {<InitiateNewSubstituteRequestCertificated />} /> */}
      {/* <Route path='/substitute_request_certificated/initiate_new_report/:reportId' component={<InitiateNewSubstituteRequestCertificated />} /> */}

      {/* Employee handbook */}
      <Route path="/employee-handBook" element={<EmployeeHandBook />} />
      <Route path="/new-handBook" element={<NewHandBook />} />
      <Route path="/assign-handBook" element={<AssignHandbook />} />
      <Route path="/timeReport/temp" element={<HtmlToPdfTimeReport />} />
      <Route path="/employee-list" element={<HandBookEmployeeList />} />
      <Route path="/employee-agreement-handbook" element={<EmployeeAgreementHandbook />} />

      <Route path="/stipend-report" element={<StipendReportTemplate />} />
      <Route path="/stipend_request/:id" element={<StipendEmployee />} />
      <Route path="/pdfForm" element={<PdfForm />} />

    </Routes>
  );
}
